import { render, staticRenderFns } from "./bar1.vue?vue&type=template&id=5709fa66&"
import script from "./bar1.vue?vue&type=script&lang=js&"
export * from "./bar1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports